module.exports = __webpack_public_path__ + "img/active_05.60fccaf7.jpg";